/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Custom Search Script
function openSearchPopup() {
    var searchPopup = document.getElementById('search-popup');
    var overlay = document.querySelector('.overlay');
    var headerSearchBar = document.querySelector('.header_search-bar');
    var checkScrollClass = headerSearchBar.classList.contains('scrolling');
    var searchContainer = document.querySelector('.site-header__search');
    var logoContainer = document.querySelector('.header__logo');
    if(checkScrollClass){
        headerSearchBar.classList.remove('scrolling');
    }   
    if (searchPopup && overlay) {
        logoContainer.style.zIndex = 999;
        searchPopup.classList.add('translate-down');
        document.getElementById('popup-search-input').focus();
        overlay.style.display = 'block';
        headerSearchBar.style.zIndex = 9999;
    }
}


function closeSearchPopup() {
    var searchPopup = document.getElementById('search-popup');
    var overlay = document.getElementById('overlay');
    var searchContainer = document.querySelector('.site-header__search');
    var headerSearchBar = document.querySelector('.header_search-bar');
    var logoContainer = document.querySelector('.header__logo');
    if (searchPopup && overlay) {   
        searchPopup.classList.remove('translate-down');
        overlay.style.display = 'none';
        logoContainer.style.zIndex = 99991;
    }
    if (window.innerWidth <= 1024) {
        // only for mobile
         searchContainer.style.zIndex = -1;
         headerSearchBar.style.zIndex = -1;
    }
}

function redirectToSearchPage() {
  var query = document.getElementById('popup-search-input').value;
  if (query) {
    window.location.href = `/search?q=${query}`;
  }
}

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.popup-search-input').forEach(function(popupSearchInput) {
        popupSearchInput.addEventListener('input', function() {
            const query = popupSearchInput.value.trim().toLowerCase();
            const popupSearchResults = document.querySelector('.search-results');
            const searchCount = document.querySelector('.search-count');
            const searchAll = document.querySelector('.search-all');
            const categoryResults = document.querySelector('.popup-search-result-category-item');
            const categoryContainer = document.querySelector('.popup-search-result-category');

            // Clear results if query is less than 3 characters
            if (query.length < 2) {
                if (searchCount) searchCount.innerHTML = '';
                if (popupSearchResults) popupSearchResults.innerHTML = '';
                if (categoryResults) categoryResults.innerHTML = '';
                if (searchAll) searchAll.style.display = 'none';
                if (categoryContainer) categoryContainer.style.display = 'none';
                return;
            }

            // Fetch product results
            fetch(`/search/suggest.json?q=${query}&resources[type]=product&limit=10&page=1`)
                .then(response => response.json())
                .then(data => {
                    console.log("First page response:", data);
                    var products = data.resources.results.products || [];
                    
                    if (products.length === 10) {
                        fetch(`/search/suggest.json?q=${query}&resources[type]=product&limit=1&page=2`)
                            .then(response => response.json())
                            .then(nextPageData => {
                                const hasMoreProducts = nextPageData.resources.results.products && 
                                                     nextPageData.resources.results.products.length > 0;
                                displaySearchResults(products, hasMoreProducts, query);
                            })
                            .catch(error => {
                                console.error('Error fetching next page:', error);
                                displaySearchResults(products, false, query);
                            });
                    } else {
                        displaySearchResults(products, false, query);
                    }
                })
                .catch(error => console.error('Error fetching search results:', error));

            // Fetch collection results
            fetch(`/search/suggest.json?q=${query}&resources[type]=collection&limit=6`)
                .then(response => response.json())
                .then(data => {
                    const collections = data.resources.results.collections || [];
                    displayCollectionResults(collections, categoryResults);
                    // Show/hide category container based on results
                    if (categoryContainer) {
                        categoryContainer.style.display = collections.length > 0 ? 'block' : 'none';
                    }
                })
                .catch(error => console.error('Error fetching collection results:', error));
        });
    });
    
});
document.addEventListener('DOMContentLoaded', function() {
    var overlay = document.getElementById('overlay');

    if (overlay) {
        overlay.addEventListener('click', function() {
            closeSearchPopup();
        });
    }
});

function displaySearchResults(products, hasMoreProducts, query) {
    const popupSearchResults = document.querySelector('.search-results');
    const searchCount = document.querySelector('.search-count');
    const searchAll = document.querySelector('.search-all');

    if (!popupSearchResults || !searchCount || !searchAll) {
        console.error('Required elements not found');
        return;
    }

    popupSearchResults.innerHTML = ''; // Clear previous results
    searchAll.style.display = 'none';
    searchCount.innerHTML = ''; // Clear search count

    if (products.length) {
        // If we have 10 products and there are more, show "10+"
        const displayCount = (products.length === 10 && hasMoreProducts) ? '10+' : products.length;
        searchCount.innerHTML = `${displayCount} produkter funnet`;
        searchAll.style.display = 'inline';

        products.forEach(product => {
            var productTitle = product.title;
            var highlightedTitle = productTitle.replace(
                new RegExp(query, 'gi'),
                match => `<strong>${match}</strong>`
            );

            // Format prices
            const price = product.price;
            const compareAtPrice = product.compare_at_price_max;
            
            // Format price with Norwegian format (1.161 or 462)
            const formatPrice = (price) => {
                // Convert to number but don't divide by 100 since we want the full number
                const number = parseInt(price);
                // Format with . as thousand separator
                return number >= 1000 
                    ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' kr'
                    : number.toString() + ' kr';
            };

            const formattedPrice = formatPrice(price);
            const formattedCompareAtPrice = compareAtPrice && compareAtPrice > price ? formatPrice(compareAtPrice) : null;

            var productElement = document.createElement('div');
            productElement.className = 'search-result-item';
            productElement.innerHTML = `
                <a href="${product.url}">
                    <img src="${product.image ? product.image : '/path/to/default-image.jpg'}" 
                         alt="${product.title}" 
                         class="product-image">
                    <div class="product-details">
                        <span class="product-title">${highlightedTitle}</span>
                        <div class="product-price">
                          <span class="current-price"><strong>${formattedPrice}</strong></span>
                            ${formattedCompareAtPrice ? `<span class="compare-at-price">${formattedCompareAtPrice}</span>` : ''}
                           
                        </div>
                    </div>
                </a>
            `;
            popupSearchResults.appendChild(productElement);
        });
    } else {
        popupSearchResults.innerHTML = '<p style="color:#000; padding: 10px;">Ingen produkter funnet.</p>';
        searchAll.style.display = 'none';
        // No search count displayed when no products found
    }
}

function displayCollectionResults(collections, container) {
    const categoryContainer = document.querySelector('.popup-search-result-category-item');

    if (!categoryContainer) {
        console.error('Collection container not found');
        return;
    }

    categoryContainer.innerHTML = ''; // Clear previous results
    
    if (collections.length === 0) {
        categoryContainer.innerHTML = '<p>No collections found.</p>';
        return;
    }

    const resultsToShow = collections.slice(0, 5);
    const hasMoreResults = collections.length > 5;

    resultsToShow.forEach(collection => {
        const collectionLink = document.createElement('a');
        collectionLink.className = 'category-button';
        collectionLink.innerHTML = collection.title;
        collectionLink.href = collection.url;
        categoryContainer.appendChild(collectionLink);
    });

    if (hasMoreResults) {
        const categoryParent = document.querySelector('.popup-search-result-category');
            
        if (categoryParent) {
            categoryParent.style.display = 'block';
        }

        const viewMoreLink = document.createElement('a');
        viewMoreLink.className = 'category-button view-more';
        viewMoreLink.innerHTML = 'Vis alle';
        viewMoreLink.href = `/search?q=${document.querySelector('#popup-search-input').value}&type=collection`;
        categoryContainer.appendChild(viewMoreLink);
    }
}

// Mini Cart Script

// If yuo want dynamic Shipping Rate
// async function getShippingRates() {
//     try {
//       const response = await fetch('/cart/shipping_rates.json?shipping_address[zip]=0025&shipping_address[country]=NO');
//       const data = await response.json();
  
//       if (data.shipping_rates && data.shipping_rates.length > 0) {
//         // Don't divide shipping price by 100 since it's already in the correct format
//         return parseFloat(data.shipping_rates[0].price);
//       }
//       return 0;
//     } catch (error) {
//       console.error('Error fetching shipping rates:', error);
//       return 0;
//     }
//   }
  
// Handle search bar scroll behavior
let lastScrollTop = 0;
const searchBar = document.querySelector('.header__search-wrapper');
const openSearchBtnMobile = document.querySelector('.open-search-btn-mobile');
const headerWrapper = document.querySelector('.header__wrapper');
window.addEventListener('scroll', function() {
  const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
  
  // If we're at the top of the page, always show the search bar
  if (currentScroll <=  80) {
    searchBar?.classList.remove('scrolling');
    openSearchBtnMobile?.classList.remove('active');
    headerWrapper.classList.remove('border-header');
    return;
  }
  
  // Add scrolling class when scrolling up, remove when scrolling down
  if (currentScroll > lastScrollTop) {
    // Scrolling down
    searchBar?.classList.remove('scrolling');
    openSearchBtnMobile?.classList.remove('active');
    headerWrapper.classList.remove('border-header');
  } else {
    // Scrolling up
    searchBar?.classList.add('scrolling');
    openSearchBtnMobile?.classList.add('active');
    headerWrapper.classList.add('border-header');
  }
  
  lastScrollTop = currentScroll;
});  

// clean product description
function cleanEmptyParagraphs(selector) {
    const elements = document.querySelectorAll(selector);
  
    elements.forEach(element => {
        const paragraphs = element.querySelectorAll('p');
    
        paragraphs.forEach(p => {
            // Only remove if the paragraph is empty AND doesn't contain any images or other elements
            if (!p.hasChildNodes() || 
                (p.children.length === 0 && (
                    p.innerHTML.trim() === "" ||
                    p.innerHTML.trim() === "&nbsp;" ||
                    p.innerHTML.trim() === " " ||
                    p.innerHTML.trim() === "<br>" ||
                    p.innerHTML.trim() === "<br/>" ||
                    p.innerHTML.trim() === "<strong><br></strong>" ||
                    p.innerHTML.trim() === "<br />"
                ))) {
                p.remove();
            }
        });
    });
}
  document.addEventListener('DOMContentLoaded', function() {
    cleanEmptyParagraphs('.description-content'); // Replace '.description-content' with the appropriate selector for your product description container.
  });

//   // Function to create and insert the add-on container
// function insertAddOnContainer() {
//     // Create the div element
//     const addOnContainer = document.createElement('div');
//     addOnContainer.className = 'rbrAddOnContainer';

//     // Get the target elements
//     const productInfo = document.querySelector('.product__info');
//     const bmrLeft = document.querySelector('.bmr-left');

//     // Function to handle the actual insertion
//     function placeElement() {
//         // Remove existing container if it exists to prevent duplicates
//         const existingContainer = document.querySelector('.rbrAddOnContainer');
//         if (existingContainer) {
//             existingContainer.remove();
//         }

//         // Check window width and insert accordingly
//         if (window.innerWidth < 768) {
//             if (productInfo) {
//                 productInfo.appendChild(addOnContainer);
//             }
//         } else {
//             if (bmrLeft) {
//                 bmrLeft.appendChild(addOnContainer);
//             }
//         }
//     }

//     // Initial placement
//     placeElement();

//     // Listen for window resize events
//     let resizeTimeout;
//     window.addEventListener('resize', function() {
//         // Debounce the resize event
//         clearTimeout(resizeTimeout);
//         resizeTimeout = setTimeout(placeElement, 250);
//     });
// }




// Function to insert the simple button
// 

document.addEventListener('DOMContentLoaded', function() {
  const hamburgerMenu = document.querySelector('.hamburger-menu');
  const customMenuDrawer = document.getElementById('custom-menu-drawer');
  const menuInner = customMenuDrawer.querySelector('.custom-menu-drawer__inner');
  const overlay = document.querySelector('.menu-drawer-overlay');
  
  // Add this function to handle overlay visibility
  function showOverlay() {
      menuInner.style.display = 'inherit';
      overlay.style.visibility = 'visible';
      overlay.style.opacity = '1';
  }

  function hideOverlay() {
      overlay.style.visibility = 'hidden';
      overlay.style.opacity = '0';
      menuInner.style.display = 'none';
  }
  
  // Toggle menu and body scroll lock
  function toggleCustomMenu() {
    const isOpen = customMenuDrawer.classList.contains('is-open');
    
    customMenuDrawer.classList.toggle('is-open');
    hamburgerMenu.classList.toggle('is-active');
    hamburgerMenu.setAttribute('aria-expanded', !isOpen);
    
    // Toggle body scroll lock when menu is open/closed
    document.body.style.overflow = isOpen ? '' : 'hidden';
    
    // Toggle overlay visibility
    if (isOpen) {
      hideOverlay();
    } else {
      showOverlay();
    }
    
    // Reset scroll position when opening menu
    if (!isOpen) {
      setTimeout(() => {
        menuInner.scrollTop = 0;
      }, 0.05);
    }
  }
  
  // Update hamburger button attributes
  if (hamburgerMenu) {
    hamburgerMenu.setAttribute('aria-controls', 'custom-menu-drawer');
    hamburgerMenu.addEventListener('click', function(event) {
      event.stopPropagation();
      toggleCustomMenu();
    });
  }
  
  // Improved submenu handling
  document.querySelectorAll('.submenu-trigger').forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const submenuId = this.dataset.submenu;
      const submenu = document.getElementById(submenuId);
      
      if (submenu) {
        // Force scroll all menus to top for iOS consistency
        document.querySelectorAll('.custom-menu__submenu--slide').forEach(menu => {
          menu.scrollTop = 0;
        });
        
        // Force parent menu to scroll top
        const parentMenu = submenu.closest('.custom-menu-drawer__inner');
        if (parentMenu) {
          parentMenu.scrollTop = 0;
        }
        
        // Add a slight delay before showing the submenu (helps with iPad rendering)
        setTimeout(() => {
          // Show submenu
          submenu.classList.add('is-visible');
          
          // Force submenu to top again after becoming visible (crucial for iOS)
          submenu.scrollTop = 0;
          
          // Update ARIA
          const arrow = this.querySelector('.custom-menu__arrow');
          if (arrow) {
            arrow.setAttribute('aria-expanded', 'true');
          }
        }, 0.50);
      }
    });
  });
  
  // Improved back navigation
  document.querySelectorAll('.custom-menu__back-wrapper').forEach(wrapper => {
    wrapper.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const submenu = this.closest('.custom-menu__submenu--slide');
      if (submenu) {
        // Update ARIA
        const submenuId = submenu.id;
        const parentArrow = document.querySelector(`[data-submenu="${submenuId}"] .custom-menu__arrow`);
        if (parentArrow) {
          parentArrow.setAttribute('aria-expanded', 'false');
        }
        
        // Add sliding out animation class
        submenu.classList.add('is-sliding-out');
        
        // Hide submenu with a small delay to ensure proper transition
        submenu.classList.remove('is-visible');
        
        // Remove sliding class after animation completes
        submenu.addEventListener('transitionend', function handler() {
          submenu.classList.remove('is-sliding-out');
          submenu.removeEventListener('transitionend', handler);
        });
        
        // Ensure parent menu is scrollable if needed and force scroll to top
        const parentMenu = submenu.parentElement.closest('.custom-menu__submenu--slide') || 
                          document.querySelector('.custom-menu-drawer__inner');
        if (parentMenu) {
          parentMenu.style.overflow = 'auto';
          parentMenu.scrollTop = 0;
        }
      }
    });
  });
  
  // Close menu when clicking outside
  document.addEventListener('click', function(event) {
    if (!customMenuDrawer.contains(event.target) && 
        !event.target.classList.contains('hamburger-menu')) {
      if (customMenuDrawer.classList.contains('is-open')) {
        // Reset all submenus
        const visibleSubmenus = customMenuDrawer.querySelectorAll('.custom-menu__submenu--slide.is-visible');
        visibleSubmenus.forEach(submenu => {
          submenu.classList.remove('is-visible');
          submenu.classList.remove('is-sliding-out');
        });
        
        // Close the menu and unlock scrolling
        customMenuDrawer.classList.remove('is-open');
        hamburgerMenu.classList.remove('is-active');
        hamburgerMenu.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        
        // Hide the overlay
        hideOverlay();
      }
    }
  });
  
  // Prevent menu from closing when clicking inside
  customMenuDrawer.addEventListener('click', function(event) {
    event.stopPropagation();
  });
  
  // Add click event listener for the overlay
  overlay.addEventListener('click', function() {
    if (customMenuDrawer.classList.contains('is-open')) {
      // Reset all submenus
      const visibleSubmenus = customMenuDrawer.querySelectorAll('.custom-menu__submenu--slide.is-visible');
      visibleSubmenus.forEach(submenu => {
        submenu.classList.remove('is-visible');
        submenu.classList.remove('is-sliding-out');
      });
      
      // Close the menu and unlock scrolling
      customMenuDrawer.classList.remove('is-open');
      hamburgerMenu.classList.remove('is-active');
      hamburgerMenu.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      
      // Hide the overlay
      hideOverlay();
    }
  });
  
  // Handle iOS scroll issues specifically
  if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
    menuInner.style.webkitOverflowScrolling = 'touch';
    
    // Apply additional fixes for iPad Air and older iOS devices
    if (/iPad/.test(navigator.userAgent)) {
      // Force hardware acceleration for smoother transitions
      document.querySelectorAll('.custom-menu__submenu--slide').forEach(submenu => {
        submenu.style.webkitOverflowScrolling = 'touch';
        submenu.style.transform = 'translateZ(0)';
        submenu.style.backfaceVisibility = 'hidden';
      });
      
      // Add extra handler for iPad-specific issues
      document.querySelectorAll('.submenu-trigger').forEach(trigger => {
        trigger.addEventListener('touchend', function(e) {
          // This additional handler helps ensure the touch event is properly handled on iPads
          const submenuId = this.dataset.submenu;
          const submenu = document.getElementById(submenuId);
          if (submenu) {
            // Force scroll reset on touchend (helps with iPad Air 2)
            setTimeout(() => {
              submenu.scrollTop = 0;
              
              // Double-check scroll position after rendering
              setTimeout(() => {
                submenu.scrollTop = 0;
              }, 100);
            }, 10);
          }
        });
      });
    }
  }
});


// Add event listener for Swym "Add all to cart" button
document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {
        if (event.target.matches('.swym-add-all-to-cart-btn')) {
            // Wait for Swym's add to cart operation to complete
            const checkCartInterval = setInterval(() => {
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        if (cart) {
                            clearInterval(checkCartInterval);
                            // Dispatch cart refresh event
                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                                bubbles: true,
                                detail: { cart: cart }
                            }));
                            
                            // Show mini-cart drawer
                            const miniCartDrawer = document.getElementById('mini-cart');
                            if (miniCartDrawer) {
                                miniCartDrawer.open = true;
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error checking cart:', error);
                        clearInterval(checkCartInterval);
                    });
            }, 500); // Check every 500ms

            // Stop checking after 5 seconds to prevent infinite loop
            setTimeout(() => {
                clearInterval(checkCartInterval);
            }, 5000);
        }
    });
});

// document.addEventListener('variant:changed', function(event) {
//     let variant = event.detail.variant; // Get the variant that was changed
//     let productForm = event.target; // Get the form that triggered the event
//     let addToCartButton = document.getElementById('AddToCart');
//     let klaviyoButton = document.querySelector('.terms-button');

//     if (variant.available) {
//         // Variant is available, show the normal button
//         addToCartButton.style.display = 'block';
//         if (klaviyoButton) {
//             klaviyoButton.style.display = 'none'; // Hide Klaviyo button
//         }
//     } else {
//         // Variant is out of stock, show the Klaviyo button
//         addToCartButton.style.display = 'none'; // Hide normal button
//         if (klaviyoButton) {
//             klaviyoButton.style.display = 'block'; // Show Klaviyo button
//         }
//     }
// });



